import { IHeaderColumn } from 'Components/TableBase/SortableTableHead';

export enum EPartnerHeaderColumnEnum {
  TITLE = 'title',
  SITES_COUNT = 'sitesCount',
  OWNER = 'owner',
  MODIFIED_TIMESTAMP = 'modifiedTimestamp',
  ACTIONS = 'actions',
}

export type TPartnerHeaderColumn = keyof typeof EPartnerHeaderColumnEnum;

export const getPartnerHeaderColumns = (enabledColumns: EPartnerHeaderColumnEnum[]) => {
  const columns: IHeaderColumn<EPartnerHeaderColumnEnum>[] = [];

  enabledColumns.forEach(column => {
    switch (column) {
      case EPartnerHeaderColumnEnum.TITLE:
        columns.push({ id: EPartnerHeaderColumnEnum.TITLE, headerName: 'Title', sortable: false });
        break;

      case EPartnerHeaderColumnEnum.SITES_COUNT:
        columns.push({
          id: EPartnerHeaderColumnEnum.SITES_COUNT,
          headerName: 'Site count',
          sortable: false,
        });
        break;

      case EPartnerHeaderColumnEnum.OWNER:
        columns.push({
          id: EPartnerHeaderColumnEnum.OWNER,
          headerName: 'Owner',
          sortable: false,
        });
        break;

      case EPartnerHeaderColumnEnum.MODIFIED_TIMESTAMP:
        columns.push({
          id: EPartnerHeaderColumnEnum.MODIFIED_TIMESTAMP,
          headerName: 'Last edited',
          sortable: true,
        });
        break;

      case EPartnerHeaderColumnEnum.ACTIONS:
        columns.push({
          id: EPartnerHeaderColumnEnum.ACTIONS,
          headerName: 'Actions',
          sortable: false,
          align: 'right',
        });
        break;
    }
  });

  return columns;
};
